export default __webpack_public_path__ + "static/media/tat_img3.4d258153.webp";